import type { FloorPlanTransform } from '@/types';
import type { EquipmentInstance } from '@/features/equipment/equipmentTypes';

/**
 * Holds the lossless DXF JSON that equipment overlays are extracted from.
 *
 * Overlays are generated on demand (View → Generate Overlays) and re-generated
 * whenever DXF layer visibility changes, so the source document has to outlive
 * the import that produced it. It lives here rather than in Redux because the
 * document is large, non-serialisable in practice, and never rendered.
 */
type DxfEquipmentSource = {
  document: unknown;
  transform: FloorPlanTransform;
  /**
   * Overlays already extracted at import time. The worker-backed load path
   * discards the entity tree once geometry is parsed, so its `document` is a
   * stub and this is the only thing left to generate overlays from.
   */
  extractedEquipment?: EquipmentInstance[];
};

let source: DxfEquipmentSource | null = null;

export function setDxfEquipmentSource(next: DxfEquipmentSource): void {
  source = next;
}

export function getDxfEquipmentSource(): DxfEquipmentSource | null {
  return source;
}

export function hasDxfEquipmentSource(): boolean {
  return source !== null;
}

export function clearDxfEquipmentSource(): void {
  source = null;
}
